module.exports = __webpack_public_path__ + "static/media/Model.5fce6a56.jpeg";